import { html, ifDefined } from 'omni-ui';
import { Om2FormFieldBase, mergeClass, SHARED_FIELD } from './common/base.js';

/**
 * Render an object input (JSON)
 */
export class Om2FormFieldObject extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'JSON Input',
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        class: SHARED_FIELD,
        default: SHARED_FIELD,
        placeholder: SHARED_FIELD,
        rows: {
          title: 'Rows',
          type: 'number',
          min: 1,
          multipleOf: 1,
        },
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: SHARED_FIELD,
      },
    },
  };

  render() {
    const { schema } = this;
    return html`
      <textarea
        class=${mergeClass('textarea is-family-code is-size-5', schema.class)}
        .name="${this.key}"
        .value=${JSON.stringify(this.data ?? schema.default, null, 2) ?? ''}
        placeholder=${ifDefined(schema.placeholder)}
        ?required=${schema.required}
        ?disabled=${schema.disabled || this._isHidden()}
        ?readonly=${schema.readonly || this.context?.readonly}
        rows=${ifDefined(schema.rows)}
        @input=${e => {
          e.stopPropagation();
          // Update dom directly with any error (don't rely on lit's update)
          const errorElem = e.target.nextElementSibling;
          let parsed;
          try {
            parsed = JSON.parse(e.target.value);
            errorElem.innerText = '';
          } catch (e2) {
            if (e.target.value === '') {
              parsed = schema.default;
              errorElem.innerText = '';
            } else {
              errorElem.innerText = e2;
            }
          }
          if (errorElem.innerText === '') {
            this.dispatchEvent(
              new CustomEvent('input', {
                detail: {
                  name: this.key,
                  value: parsed,
                },
                bubbles: true,
              })
            );
          }
        }}
      ></textarea>
      <span class="has-text-danger is-size-5"></span>
    `;
  }
}

Om2FormFieldObject.register('object');
